import { render, staticRenderFns } from "./FilterableAnnotoriousRenderer.vue?vue&type=template&id=2597b977&scoped=true&"
import script from "./FilterableAnnotoriousRenderer.vue?vue&type=script&lang=js&"
export * from "./FilterableAnnotoriousRenderer.vue?vue&type=script&lang=js&"
import style0 from "./FilterableAnnotoriousRenderer.vue?vue&type=style&index=0&id=2597b977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597b977",
  null
  
)

export default component.exports